import React from 'react';
import logo from '../../img/FACEA13.png';

function Introduccion() {

    return (
        <div>
            <div className="jumbotron">
                <div className="container">
                    <h3>Programa de Mentorías 2022 de la Pontificia Universidad Católica de Chile</h3>
                    <br/>
                    <img src={logo} className="img-fluid" alt="logo"></img>
                    <br/>
                    <br/>
                    <p>Somos una comunidad de Ingenieros Comerciales UC que, en conjunto con el Centro de Enlace, contribuimos en la inserción laboral de los alumnos y recién egresados de la Facultad.</p>
                    <p>Te presentamos nuestra nueva plataforma del Programa Mentoring para poder mejorar la experiencia entre alumnos y mentores.</p>
                    <div className="row">
                        <div className="col-lg col-md-12 col-sm-12">
                            <div className="page-header row no-gutters py-4">
                                <div className="col-12 col-sm-4 text-center text-sm-left mb-0">
                                    <h3 className="page-title">¿Cómo lo hacemos?</h3>
                                </div>
                            </div>
                            
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item">Match entre mentor y alumno, de acuerdo a los intereses del alumno y la experiencia laboral del mentor.</li>
                                <li className="list-group-item">Implementación y feedback del test psicolaboral Extended DISC a los alumnos.</li>
                                <li className="list-group-item">Tres reuniones semestrales, a través del canal que más les acomode: Google Meets, Microsoft Teams, Zoom, etc. Las reuniones están previamente pauteadas para cumplir con los objetivos del programa.</li>
                                <li className="list-group-item">Evaluación de cada reunión por parte del mentor y del alumno.</li>
                            </ul>
                        
                        </div>                
                    </div> 
                </div>
            </div>
        </div>
    )
}

export default Introduccion